// Simple i18n for ES (default, Argentinian) and EN
import React, { createContext, useContext, useState, useCallback } from "react";

export const translations = {
  es: {
    nav: {
      about: "Nosotros",
      menu: "Carta",
      gallery: "Galería",
      testimonials: "Opiniones",
      contact: "Contacto",
      reserve: "Reservar",
    },
    hero: {
      overline: "Palermo · Buenos Aires",
      title_1: "Una noche",
      title_2: "para quedarse.",
      subtitle:
        "Cocina de autor, tragos de coctelería y un ambiente íntimo donde cada detalle está pensado para disfrutar sin apuros.",
      cta_reserve: "Reservar por WhatsApp",
      cta_menu: "Ver la carta",
      open_now: "Abierto ahora · hasta las 2 a.m.",
    },
    about: {
      overline: "Nuestra historia",
      title: "Gastronomía, vino y arquitectura.",
      p1: "En el corazón de Palermo, TINTA es una parada obligada para los amantes de la buena mesa. Un espacio íntimo, tenue y cálido, donde la cocina de autor se encuentra con una coctelería creativa y una carta de vinos cuidadosamente seleccionada.",
      p2: "Abrimos de martes a domingos desde las 20 hs, con reservas recomendadas para quienes buscan una noche distinta — ya sea una cita, una cena entre amigos o una celebración.",
      stat_1_num: "4.4",
      stat_1_label: "★ en Google · +2.300 opiniones",
      stat_2_num: "93K+",
      stat_2_label: "Seguidores en Instagram",
      stat_3_num: "10%",
      stat_3_label: "Descuento pagando en efectivo",
    },
    menu: {
      overline: "Carta destacada",
      title: "Platos y tragos que dejan huella.",
      subtitle:
        "Una selección curada de nuestros clásicos más elegidos por quienes ya nos visitaron.",
      items: [
        {
          name: "Sushi Miami Hot",
          desc: "Fresco, con un toque dulzón justo que lo hace único. Una de las sorpresas más elogiadas.",
          tag: "Signature",
        },
        {
          name: "Lomo con papas noisette",
          desc: "En su punto, súper sabroso y bien acompañado. Un clásico que no falla.",
          tag: "Clásico",
        },
        {
          name: "Ravioles de ternera",
          desc: "Abundantes, bien rellenos y muy bien logrados. Ideal para compartir.",
          tag: "Pastas",
        },
        {
          name: "Fake Watermelon",
          desc: "Trago de autor fresco y perfecto para una noche de verano en Palermo.",
          tag: "Coctelería",
        },
        {
          name: "Sangría de la casa",
          desc: "Fresca, balanceada y pensada para disfrutar sin apuros.",
          tag: "Coctelería",
        },
        {
          name: "Volcán de chocolate",
          desc: "Tibio por fuera, con el centro fluido. El postre que cierra la noche perfecta — recomendado por nuestros comensales.",
          tag: "Postre",
        },
      ],
    },
    gallery: {
      overline: "Ambiente",
      title: "Un rincón pensado para los sentidos.",
      subtitle:
        "Madera oscura, luz tenue, velas y cuero. Un lugar para enamorarse — de la comida, de la noche, de alguien.",
    },
    testimonials: {
      overline: "Dicen de nosotros",
      title: "Historias reales de nuestros comensales.",
      subtitle: "Reseñas verificadas en Google Maps.",
      reviews: [
        {
          name: "Florencia Sardella",
          role: "Local Guide · 19 opiniones",
          when: "Hace 4 meses",
          rating: 5,
          text:
            "La experiencia fue realmente muy buena. El lomo estaba en su punto, el sushi fue una sorpresa total y los ravioles de ternera quedaron encantados. Delfina, la mesera, fue un amor: me recomendó un trago de autor pensado según mis gustos y la rompió.",
        },
        {
          name: "Pedro Castagnoli",
          role: "Local Guide · 297 opiniones",
          when: "Hace 4 meses",
          rating: 5,
          text:
            "Lugar íntimo, ideal para una cita. Los tragos de autor son lo mejor del lugar: el Fake Watermelon riquísimo y la sangría fresca. El flan, excelente. Destaco la atención de Micaela.",
        },
        {
          name: "Rocio Vazquez",
          role: "5 opiniones",
          when: "Hace 2 meses",
          rating: 5,
          text:
            "Hermoso lugar elegante con clase. El servicio de Micaela fue excepcional. Muy delicioso todo y el ambiente es ideal para ir en pareja, familia o amigos tranquilos.",
        },
        {
          name: "facundo",
          role: "Local Guide · 11 opiniones",
          when: "Hace 3 meses",
          rating: 5,
          text:
            "La comida vino súper rápido. Los chicos super copados. Hay un increíble ambiente para cita íntima y en efectivo hay 10% de descuento.",
        },
        {
          name: "laura perez",
          role: "Local Guide · 19 opiniones",
          when: "Hace 2 meses",
          rating: 5,
          text:
            "Después de más de un año sin tener una cita romántica fue una experiencia muy linda. El ambiente es hermoso, luz tenue, música calma. Sin dudas volvería, muy recomendable.",
        },
        {
          name: "Micaela Melione",
          role: "Local Guide · 100 opiniones",
          when: "Hace 3 meses",
          rating: 5,
          text:
            "Hermoso lugar, con un ambiente súper romántico y amplio. La comida es muy rica y el servicio atento. Los tragos Bubba y Berries Crimson muy recomendables.",
        },
      ],
    },
    contact: {
      overline: "Visitanos",
      title: "Nos encontrás en Palermo.",
      address_label: "Dirección",
      address: "José A. Cabrera 5621, Palermo, CABA",
      hours_label: "Horarios",
      hours: [
        ["Martes a Domingo", "20:00 – 02:00"],
        ["Lunes", "Cerrado"],
      ],
      phone_label: "Teléfono",
      phone: "011 5821-4406",
      ig_label: "Instagram",
      ig_handle: "@tinta.ba",
      reserve_title: "Reservá tu mesa",
      reserve_desc:
        "Escribinos por WhatsApp y coordinamos todo. Te respondemos rápido.",
      reserve_cta: "Chatear por WhatsApp",
      note: "Se recomienda reservar · 10% de descuento pagando en efectivo",
    },
    footer: {
      tagline: "Amantes de la gastronomía y la arquitectura.",
      rights: "Todos los derechos reservados.",
      nav_title: "Navegación",
      contact_title: "Contacto",
      follow_title: "Seguinos",
    },
    whatsapp_float: "Reservá por WhatsApp",
  },
  en: {
    nav: {
      about: "About",
      menu: "Menu",
      gallery: "Gallery",
      testimonials: "Reviews",
      contact: "Contact",
      reserve: "Book",
    },
    hero: {
      overline: "Palermo · Buenos Aires",
      title_1: "A night",
      title_2: "to remember.",
      subtitle:
        "Author's cuisine, craft cocktails and an intimate atmosphere where every detail is designed to be savored, unhurried.",
      cta_reserve: "Book via WhatsApp",
      cta_menu: "See the menu",
      open_now: "Open now · until 2 a.m.",
    },
    about: {
      overline: "Our story",
      title: "Gastronomy, wine and architecture.",
      p1: "In the heart of Palermo, TINTA is a must-visit for food lovers. An intimate, dim and warm space where chef-driven cuisine meets creative cocktails and a carefully curated wine list.",
      p2: "Open Tuesday through Sunday from 8 PM, with reservations recommended for those seeking a different kind of evening — whether it's a date, dinner with friends or a celebration.",
      stat_1_num: "4.4",
      stat_1_label: "★ on Google · 2,300+ reviews",
      stat_2_num: "93K+",
      stat_2_label: "Followers on Instagram",
      stat_3_num: "10%",
      stat_3_label: "Discount when paying cash",
    },
    menu: {
      overline: "Highlights",
      title: "Dishes and drinks that leave a mark.",
      subtitle:
        "A curated selection of our most-loved classics, picked by the people who've already dined with us.",
      items: [
        {
          name: "Sushi Miami Hot",
          desc: "Fresh, with a subtle sweet touch that makes it unique. One of the most praised surprises.",
          tag: "Signature",
        },
        {
          name: "Tenderloin with noisette potatoes",
          desc: "Perfectly cooked, deeply flavorful and beautifully plated. A classic that never misses.",
          tag: "Classic",
        },
        {
          name: "Beef ravioli",
          desc: "Generous, well-stuffed and expertly crafted. Perfect for sharing.",
          tag: "Pasta",
        },
        {
          name: "Fake Watermelon",
          desc: "A signature cocktail — fresh and perfect for a summer night in Palermo.",
          tag: "Cocktail",
        },
        {
          name: "House Sangria",
          desc: "Fresh, balanced and made to be enjoyed slowly.",
          tag: "Cocktail",
        },
        {
          name: "Chocolate lava cake",
          desc: "Warm on the outside, molten center. The dessert that closes the perfect night — loved by our guests.",
          tag: "Dessert",
        },
      ],
    },
    gallery: {
      overline: "Atmosphere",
      title: "A corner designed for the senses.",
      subtitle:
        "Dark wood, soft lighting, candles and leather. A place to fall in love — with the food, with the night, with someone.",
    },
    testimonials: {
      overline: "What people say",
      title: "Real stories from our guests.",
      subtitle: "Verified reviews on Google Maps.",
      reviews: [
        {
          name: "Florencia Sardella",
          role: "Local Guide · 19 reviews",
          when: "4 months ago",
          rating: 5,
          text:
            "The experience was truly great. The tenderloin was spot on, the sushi was a total surprise and the beef ravioli were loved. Delfina, our server, was a sweetheart: she recommended a signature cocktail based on my tastes and it was amazing.",
        },
        {
          name: "Pedro Castagnoli",
          role: "Local Guide · 297 reviews",
          when: "4 months ago",
          rating: 5,
          text:
            "Intimate place, ideal for a date. The signature cocktails are the best part: the Fake Watermelon was delicious and the sangria fresh. The flan, excellent. Special mention to Micaela for the great service.",
        },
        {
          name: "Rocio Vazquez",
          role: "5 reviews",
          when: "2 months ago",
          rating: 5,
          text:
            "Beautiful, elegant place with class. Micaela's service was exceptional. Everything was delicious and the atmosphere is ideal for couples, family or quiet friends.",
        },
        {
          name: "facundo",
          role: "Local Guide · 11 reviews",
          when: "3 months ago",
          rating: 5,
          text:
            "Food came super fast. The staff was amazing. There's an incredible atmosphere for an intimate date and a 10% discount when paying cash.",
        },
        {
          name: "laura perez",
          role: "Local Guide · 19 reviews",
          when: "2 months ago",
          rating: 5,
          text:
            "After more than a year without a romantic date, it was a wonderful experience. The atmosphere is beautiful, soft lighting, calm music. I'd definitely come back. Highly recommended.",
        },
        {
          name: "Micaela Melione",
          role: "Local Guide · 100 reviews",
          when: "3 months ago",
          rating: 5,
          text:
            "Beautiful place with a super romantic and spacious atmosphere. The food is very tasty and the service attentive. The Bubba and Berries Crimson cocktails are highly recommended.",
        },
      ],
    },
    contact: {
      overline: "Visit us",
      title: "You'll find us in Palermo.",
      address_label: "Address",
      address: "José A. Cabrera 5621, Palermo, Buenos Aires",
      hours_label: "Hours",
      hours: [
        ["Tuesday to Sunday", "8:00 PM – 2:00 AM"],
        ["Monday", "Closed"],
      ],
      phone_label: "Phone",
      phone: "+54 11 5821-4406",
      ig_label: "Instagram",
      ig_handle: "@tinta.ba",
      reserve_title: "Book your table",
      reserve_desc:
        "Message us on WhatsApp and we'll take care of the rest. We reply quickly.",
      reserve_cta: "Chat on WhatsApp",
      note: "Reservations recommended · 10% off when paying cash",
    },
    footer: {
      tagline: "Lovers of gastronomy and architecture.",
      rights: "All rights reserved.",
      nav_title: "Navigation",
      contact_title: "Contact",
      follow_title: "Follow us",
    },
    whatsapp_float: "Book on WhatsApp",
  },
};

const I18nContext = createContext({ lang: "es", t: translations.es, toggle: () => {} });

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState("es");
  const toggle = useCallback(() => {
    setLang((prev) => (prev === "es" ? "en" : "es"));
  }, []);
  const value = { lang, t: translations[lang], toggle, setLang };
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
